<template>
    <div>
        <v-layout wrap row justify-center align-center text-xs-center pb-5 mt-5 class="cont_page">
            <v-flex xs12 sm9 md7 mt-4 class="text-xs-left">
                <h1 class="animated bounceIn dura-1"><span class="icon-titulo"></span>Objetivos</h1>
                <h2 class="animated bounceIn dura-1">Objetivo general</h2>
                <p class="animated fadeIn dura-2">Identificar y reconocer los conceptos básicos para el monitoreo de atmósferas, y así definir controles en atmósferas peligrosas que puedan afectar directa o indirectamente la integridad de las personas, el medio ambiente o las instalaciones.</p>
                <h2 class="animated bounceIn dura-4">Objetivos específicos</h2>
                <ol class="animated fadeIn dura-5">
                    <li><span>Conocer los conceptos básicos aplicables al monitoreo de atmósferas.</span></li>
                    <li><span>Identificar los componentes de los equipos portátiles para el monitoreo de atmósferas.</span></li>
                    <li><span>Conocer el paso a paso definido para el monitoreo y calibración de equipos de monitoreo.</span></li>
                </ol>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
import nextConditions from "../../js/mixins/nextConditions";
export default {
    mixins: [nextConditions],
    data() {
        return {}
    },
    mounted() {
        setTimeout(() => {
            this.$store.commit('nextShow', true)
        }, 3000);
    },
}
</script>

<style lang="scss" scoped>
@import '../../sass/globals';
.icon-titulo {
    content: url('../../assets/imagenes_compartidas/icon-titulo.png');
    align-items: center;
    justify-content: start;
    width: 15px;
    height: 15px;
}

ol {
    list-style: none;
    counter-reset: my-awesome-counter;
    padding-left: 10px;
}

ol li {
    counter-increment: my-awesome-counter;
    display: flex;
    align-items: center;
    justify-content: start;
    span {
        margin: 0.5em;
        padding: 0.5em;
        border-left: 2px solid $color-complement-one;
    }
}

ol li::before {
    content: counter(my-awesome-counter) ". ";
    color: $color-primary;
    font-weight: bold;
    margin-right: 0.01em;
}

li {}

.container-module {
    text-align: left;
    p {
        margin: 0;
        padding: 0;
    }
    img {
        width: 80px;
        display: inline-block;
        vertical-align: middle;
    }
    .modulo-name {
        display: inline-block;
        vertical-align: middle;
        width: 80%;
        text-align: left;
        padding-left: 10px;
    }
    @media screen and (max-width: 500px) {
        text-align: center;
        img {
            width: 40%;
        }
        .modulo-name {
            width: 100%;
            padding-left: 0px;
        }
    }
}
</style>